import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { AnimateModule, BasicPage } from '@pro-connect/shared';
import { CityComponent } from '../../components/pillar/city.component';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@Component({
  templateUrl: './singapur.component.html',
  styleUrls: ['./singapur.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AnimateModule, CityComponent],
})
export class SingapurComponent extends BasicPage {
  public override readonly loading = signal(false);
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  public readonly plan: { title: string; list: string[] }[] = [
    {
      title: 'DZIEŃ I i II - AZJATYCKIE POWITANIE',
      list: [
        'Po wylądowaniu śniadanie i wizyta w Walking on Sunshine – kawiarnia i salon fryzjerski w jednym',
        'Wizyta w centrum handlowym na Orchard Road – czas na modowy spacer i pierwsze zakupy',
        'Czas na relaks w hotelu, spokojny wieczór i kolacja',
      ],
    },
    {
      title: 'DZIEŃ III - Z SINGAPUREM U STÓP',
      list: [
        'Wizyta w salonie fryzjerskim',
        'Spotkanie w Akademii L’Oréal',
        'Lunch w Chinatown i hawkerach z gwiazdkami Michelin!',
        'Wizyta w Gardens by The Bay – symbolu Singapuru#2',
        'Kolacja w Marina Bay Sands z oszałamiającą panoramą na miasto – symbolu Singaupuru numer 1',
      ],
    },
    {
      title: 'DZIEŃ IV - LECIMY NA PENANG',
      list: [
        'Dla chętnych – poranny spacer po budzącym się do życia azjatyckim tygrysie',
        'Przelot na egzotyczną, malezyjską wyspę Penang',
        'Czas na odpoczynek i poznawanie okolic hotelu',
        'Kolacja przy plaży',
        'Wieczorne party w Hard Rock Disco',
      ],
    },
    {
      title: 'DZIEŃ V - GEORGETOWN & PRIVE BY DS',
      list: [
        'Stolica wyspy Penang – kolonialne miasteczko Georgetown',
        'Świątynia Kek Lo Si – symbol wyspy',
        'Lunch w Food Paradise – scena streefoodowa w mieście!',
        'Wizyta w kolejnym salonie fryzjerskim',
        'Wieczorem powrót do hotelu, kolacja i odpoczynek',
      ],
    },
    {
      title: 'DZIEŃ VI -  PENANG & CHILL',
      list: [
        'Przedostatni dzień przed powrotem do Polski - totalne nicnierobienie 😊',
        'Chill nad basenem i na plaży, a dla chętnych wypad do Georgetown na pyszny street food',
      ],
    },
    {
      title: 'DZIEŃ VI -   KUALA LUMPUR',
      list: [
        'Przelot z wyspy Penang do Malezji – do Kuala Lumpur',
        'Wizyta w Akademii L’Oréal w Kuala Lumpur i/lub w salonie fryzjerskim',
        'Zakończenie wyjazdu w naprawdę wielkim stylu - prywatny apartament w hotelu z zapierającym dech widokiem na Petronas Towers i dostępem do basenu na dachu',
        'Około północy przelot powrotny do Polski',
      ],
    },
  ];

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this._pushLayer();
  }

  private _pushLayer(): void {
    this._angulartics2GoogleTagManager.pushLayer({
      brand: 'LDB',
      language: 'pl',
      country: 'Pl',
      siteTypeLevel: this._isDevelopment ? 'test' : 'main',
      pageCategory: 'trip',
      geoIPLocation: 'Pl',
      uiLoggedStatus: !!this.user() ? 'logged' : 'not logged',
      uiType: this.user()?.type,
    });
  }
}
